export default "__VITE_ASSET__3e5c38e6__"